export default {
  jobsProfile: {
    occupationDataTabs: "v1/fa/jobs-profile/occupation-data/tabs",
    occupationData: "v1/fa/jobs-profile/occupation-data",
    occupationDataDetail: "v1/fa/jobs-profile/occupation-data/{0}",
    occupationDataClone: "v1/fa/jobs-profile/occupation-data/{0}/clone",
    occupationDataDetails: "v1/fa/jobs-profile/occupation-data/{0}/details",
    occupationDataSelectedIndicators:
      "v1/fa/jobs-profile/occupation-data/{0}/selected-indicators",
    occupationDataSelectedMyIndicators:
      "v1/fa/jobs-profile/occupation-data/{0}/selected-my-indicators",
    occupationDataIndicator:
      "v1/fa/jobs-profile/occupation-data/{0}/indicators/{1}",
    occupationDataTasks:
      "v1/fa/jobs-profile/occupation-data/{0}/task-statement",
    occupationDataTask: "v1/fa/jobs-profile/task-statement",
    occupationDataTaskId: "v1/fa/jobs-profile/task-statement/{0}",
    occupationDataTechnologies:
      "v1/fa/jobs-profile/occupation-data/{0}/technology-skill",
    occupationDataTechnology: "v1/fa/jobs-profile/technology-skill",
    occupationDataTechnologyId:
      "v1/fa/jobs-profile/occupation-data/{0}/standard-product/{1}/technology-skill",
    occupationDataToolsUsed:
      "v1/fa/jobs-profile/occupation-data/{0}/tools-used",
    occupationDataToolUsed: "v1/fa/jobs-profile/tools-used",
    occupationDataToolsUsedId:
      "v1/fa/jobs-profile/occupation-data/{0}/standard-product/{1}/tools-used",
    occupationDataWorkActivities:
      "v1/fa/jobs-profile/occupation-data/{0}/work-activity",
    occupationDataWorkActivity: "v1/fa/jobs-profile/work-activity",
    occupationDataWorkContexts:
      "v1/fa/jobs-profile/occupation-data/{0}/work-context",
    occupationDataWorkContext: "v1/fa/jobs-profile/work-context",
    occupationDataWorkContextId:
      "v1/fa/jobs-profile/occupation-data/{0}/content-model-reference/{1}/work-context",
    occupationDataWorkActivityId:
      "v1/fa/jobs-profile/occupation-data/{0}/content-model-reference-code/{1}/work-activity",
    occupationDataDetailWorkActivities:
      "v1/fa/jobs-profile/occupation-data/{0}/detail-work-activity",
    occupationDataDetailWorkActivity: "v1/fa/jobs-profile/detail-work-activity",
    occupationDataDetailWorkActivitiesDetail:
      "v1/fa/jobs-profile/detail-work-activity/{0}",
    occupationDataDetailWorkActivitiesDetailCode:
      "v1/fa/jobs-profile/occupation-data/{0}/detail-work-activity/{1}",
    occupationDataSkills: "v1/fa/jobs-profile/occupation-data/{0}/skill",
    occupationDataSkill: "v1/fa/jobs-profile/occupation-data/{0}/skill/{1}",
    occupationDataKnowledge: "v1/fa/jobs-profile/occupation-data/{0}/knowledge",
    occupationDataKnowledgeDetail:
      "v1/fa/jobs-profile/occupation-data/{0}/knowledge/{1}",
    occupationDataAbilities: "v1/fa/jobs-profile/occupation-data/{0}/abilities",
    occupationDataAbilityDetail:
      "v1/fa/jobs-profile/occupation-data/{0}/abilities/{1}",
    occupationDataWorkValues:
      "v1/fa/jobs-profile/occupation-data/{0}/work-values",
    occupationDataWorkValue:
      "v1/fa/jobs-profile/occupation-data/{0}/work-values/{1}",
    occupationDataWorkStyles:
      "v1/fa/jobs-profile/occupation-data/{0}/work-styles",
    occupationDataWorkStyle:
      "v1/fa/jobs-profile/occupation-data/{0}/work-styles/{1}",
    occupationDataInterests: "v1/fa/jobs-profile/occupation-data/{0}/interests",
    occupationDataInterest:
      "v1/fa/jobs-profile/occupation-data/{0}/interests/{1}",
    occupationDataEducations:
      "v1/fa/jobs-profile/occupation-data/{0}/educations",
    occupationDataEducation:
      "v1/fa/jobs-profile/occupation-data/{0}/educations/{1}",
    occupationDataJobZone: "v1/fa/jobs-profile/occupation-data/{0}/job-zone",
    occupationDataRelatedJobs:
      "v1/fa/jobs-profile/occupation-data/{0}/related-occupation",
    occupationDataIndicators:
      "v1/fa/jobs-profile/occupation-data/{0}/indicators",
    occupationDataMyIndicators:
      "v1/fa/jobs-profile/occupation-data/{0}/my-indicators",
    occupationDataIndicatorId:
      "v1/fa/jobs-profile/occupation-data/{0}/indicators/{1}",
    occupationDataParvandeh:
      "v1/fa/jobs-profile/occupation-data/{0}/parvandeh-list",
    occupationDataParvandehCode:
      "v1/fa/jobs-profile/occupation-data/{0}/calculate-person-matching",
    occupationDataParvandehDetails:
      "v1/fa/jobs-profile/occupation-data/{0}/parvandeh/{1}/details",
    jobpReferences: "v1/fa/jobs-profile/jobp-references",
    jobpReferencesDetail: "v1/fa/jobs-profile/jobp-references/{0}",
  },
};
